import {ProductPackageData} from "../types/product-package-modal.types";

export const defaultProductPackageData: ProductPackageData = {
  id: 0,
  technicalParametersId: 0,
  packageName: 'Новая',
  length: 0,
  width: 0,
  height: 0,
  weight: 0,
  quantity: 0,
  packageType: '',
  comment: '',
  history: null,
  nmId: null,
  sku: null
}
